import axios from "axios";
import { ALT_DOMAIN_ID, API_HOST } from "@/core/variables";
import { EntityCreate, EntityUpdate } from "@/model";


class EntityRepository {
    getTags = async (agentId: number) => {
        return axios
            .get(`${API_HOST}/v1/agents/${agentId}/domains/${ALT_DOMAIN_ID}/tags`)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    read = async (agentId: number, entityId: string) => {
        return axios.get(`${API_HOST}/v1/agents/${agentId}/domains/${ALT_DOMAIN_ID}/entities/${entityId}`);
    };

    find = async (
        agentId: number,
        page: number,
        size: number,
        is_option_sort: boolean,
        option_list: string,
        sort: string,
        keyword?: string,
        searchType?: string
    ) => {
        return axios
            .get(`${API_HOST}/v1/agents/${agentId}/domains/${ALT_DOMAIN_ID}/entities`, {
                params: { page, size, is_option_sort, option_list, keyword, sort, search_type: searchType },
            });
    };

    create = async (form: EntityCreate) => {
        return axios.post(`${API_HOST}/v1/agents/${form.agent_id}/domains/0/entities`, {
            ...form
        });
    };

    update = async (form: EntityUpdate) => {
        return axios.put(`${API_HOST}/v1/agents/${form.agent_id}/domains/0/entities/${form.entity_id}`, {
            ...form
        });
    };

    deleteMany = async (agentId: number, ids?: string[], keyword?: string, searchType?: string, optionList?: string) => {
        const params = new URLSearchParams();
        ids?.forEach((id) => params.append("ids", `${id}`));
        if (keyword)
            params.append("keyword", keyword);
        if (searchType)
            params.append("search_type", searchType);
        if (optionList)
            params.append("option_list", optionList);

        return axios.delete(`${API_HOST}/v1/agents/${agentId}/domains/0/entities`,{
            params: params
        });
    };

    import = async (agentId: number, file: File, isCleanImport?: boolean) => {
        const form = new FormData();
        const is_clean_import = isCleanImport ? '1' : '0';
        form.append("is_clean_import", is_clean_import);
        form.append("file", file);

        return axios
            .post(`${API_HOST}/v1/agents/${agentId}/domains/${ALT_DOMAIN_ID}/entities/import`, form)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    export = (agentId: number, params?: {ids?: string[], keyword?: string, searchType?: string, optionList?: string}) => {
        const urlParams = new URLSearchParams();
        params?.ids?.forEach(id => urlParams.append("ids", id));
        if (params?.keyword)
            urlParams.append("keyword", params?.keyword);
        if (params?.searchType)
            urlParams.append("search_type", params?.searchType);
        if (params?.optionList)
            urlParams.append("option_list", params?.optionList);

        window.open(`${API_HOST}/v1/agents/${agentId}/domains/${ALT_DOMAIN_ID}/entities/export?${urlParams}`);
    };
}

const entityRepository = new EntityRepository();
export default entityRepository;